<template>
  <a-config-provider :locale="expand.locale">
    <div id="index" class="index">
      <div class="container">
        <router-view />
      </div>
    </div>
  </a-config-provider>
  <Statistical />
</template>

<script lang="ts" type="text/tsx">
import AntDesign from 'ant-design-vue';
import Locale from 'ant-design-vue/lib/locale-provider/zh_CN';

import { DataInterface } from '@interface/public';
import Test from '@template/_component/test.vue';
import Statistical from '@template/_component/statistical.vue';

export default {
  name: 'index',
  components: {
    Test,
    Statistical
  },
  data(): DataInterface {
    return {
      expand: {
        locale: Locale
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        $Store.Public().$patch({
          router: newData.path
        });
      }
    }
  },
  beforeCreate(): void {
    $Application.Main.use(AntDesign);
  },
  mounted(): void {
    $Store.User().filterLink();
    this.resize();
  },
  methods: {
    /**
     * 改变Rem
     */
    changeRem(): void {
      const width = $Store.Public().width;
      let fontSize = width / $Enum.GridEnum.Mobile * 100;
      
      // width >= $Enum.GridEnum.PC && (fontSize = 75);
      fontSize > 100 && (fontSize = 100);
      document.documentElement.style.fontSize = `${ fontSize }px`;
    },
    
    /**
     * 改变尺寸
     */
    resize(): void {
      $FN.Resize(() => {
        $Store.Public().$patch({
          width: innerWidth,
          height: innerHeight
        });
        $Store.Public().updateGrid();
        this.changeRem();
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

.index {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  
  .container {
    overflow: hidden;
    position: relative;
    width: 100%;
  }
}
</style>
<style lang="less" rel="stylesheet/less">
@import '@node_modules/ant-design-vue/dist/antd.css';
@import '@node_modules/swiper/swiper.less';
@import '@node_modules/swiper/modules/autoplay/autoplay.less';
@import '@node_modules/swiper/modules/pagination/pagination.less';
@import '@node_modules/swiper/modules/effect-coverflow/effect-coverflow.less';
@import '@node_modules/aos/dist/aos.css';

@import '@resource/css/_global.less';
</style>